import { useSearchParams } from "react-router-dom";

/**
 * Open the settings modal at a given tab. The modal is URL-driven (`?settings=`),
 * so any surface can deep-link into it without threading state.
 *
 * Lives outside `SettingsModal.tsx` on purpose: a `.tsx` that exports both a
 * component and a hook falls back to a full reload under Fast Refresh.
 */
export function useOpenSettings(tab: string): () => void {
  const [, setSearchParams] = useSearchParams();
  return () => setSearchParams((prev) => { prev.set("settings", tab); return prev; });
}
